const CONSUMPTION_LABEL_COLOR = "#48525C";
export const CONSUMPTION_UNIT_COLOR = "#5B6670";

export const CONSUMPTION_LABEL_SX = {
	color: "#48525C",
	fontSize: "0.75rem",
	fontWeight: 500,
	lineHeight: 1.35,
} as const;

export const CONSUMPTION_VALUE_SX = {
	fontSize: "1.75rem",
	fontVariantNumeric: "tabular-nums",
	fontWeight: 600,
	lineHeight: 1,
} as const;

export const CONSUMPTION_UNIT_SX = {
	color: CONSUMPTION_UNIT_COLOR,
	fontSize: "0.875rem",
	fontWeight: 400,
	lineHeight: 1.2,
} as const;

export const CONSUMPTION_CAPTION_SX = {
	color: CONSUMPTION_LABEL_COLOR,
	fontSize: "0.75rem",
	fontWeight: 400,
	lineHeight: 1.4,
} as const;

export const CONSUMPTION_TABULAR_SX = {
	fontVariantNumeric: "tabular-nums",
} as const;

export const CONSUMPTION_FOCUS_RING_SX = {
	borderRadius: 1,
	outline: "2px solid currentColor",
	outlineOffset: 2,
} as const;
